import React from 'react'
import { Input, InputNumber, Button, Select, Popconfirm, Tooltip, Typography, Space } from 'antd'
import './scrubCopy.css'
import getScrubData from './getScrubData'
import { Http } from '../../../../utils'
import moment from 'moment'
import Cookies from 'universal-cookie'
import constants, { compliance as const_comp } from '../../../../constants/constants'
import cssconstants from '../../../../constants/cssconstants'
import deleteIcon from '../../../../assets/images/delete.svg'
import { CheckCircleTwoTone } from '@ant-design/icons'

const cookies = new Cookies()
const { Option } = Select

class ScrubCopy extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      flightNo: '',
      station: '',
      maxConfig: {
        PMC: 0,
        PAG: 0,
        LD2: 0,
        LD3: 0,
        LD48FQA: 0,
      },
      plannedConfig: {
        PMC: 0,
        PAG: 0,
        LD2: 0,
        LD3: 0,
        LD48FQA: 0,
      },
      finalConfig: {
        PMC: 0,
        PAG: 0,
        LD2: 0,
        LD3: 0,
        LD48FQA: 0,
      },
      user:{},
      date: false,
      workarea: [],
      workareaData: {},
      summary: '',
      summaryRows: [],
      timezone: new Cookies().get('timezone'),
    }
  }
  componentDidMount() {
    this.setData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setData()
    }
  }

  componentWillUnmount() {
    this.setState()
  }

  setData = () => {
    if(this.props.data && this.props.data.id) {
      let headers = { station: this.state.station }
      Http.get('/scrub_flight_list', {
        params: { id: this.props.data.id },
        headers
      })
        .then(({ data }) => {
          this.setState({ flights: data.data?.[0] || {} }, () => {
            let scrubData = getScrubData(data.data?.[0] || {}, this.props.priorityData || [])
            this.setState({ ...scrubData })
          })
        })
    }
  }


  updateConfig = (section, field, value) => {
    this.setState((prevState) => ({
      [section]: {
        ...prevState[section],
        [field]: value,
      },
    }))
  }

  updateResponseRow = (workAreaName, rowKeyPrefix, rowIndex, field, value) => {
    this.setState((prevState) => ({
      workareaData: {
        ...prevState.workareaData,
        [workAreaName]: {
          ...prevState.workareaData[workAreaName],
          [rowKeyPrefix]: prevState.workareaData[workAreaName][rowKeyPrefix].map((row, index) => {
            if (index === rowIndex) {
              return {
                ...row,
                [field]: value,
              }
            }
            return row
          }),
        },
      },
    }))
  }

  addResponseRow = () => {
    this.setState((prevState) => ({
      summaryRows: [
        ...prevState.summaryRows,
        {
          awb_no: '',
          location: '',
          delay: 0,
          pri: '',
          prod_code: '',
          yesNo: 'No',
          builtUlds: '',
          comments: '',
        }
      ],
    }))
  }

  removeResponseRow = (rowKey) => {
    this.setState((prevState) => {
      return { summaryRows: prevState.summaryRows.filter((row, index) => index !== rowKey) }
    })
  }

  renderConfigInput = (field, section) => (
    <div className='scrub-config-cell'>
      <InputNumber
        min={0}
        value={this.state[section][field]}
        onChange={(value) => this.updateConfig(section, field, value || 0)}
        controls={false}
        size='small'
      />
    </div>
  )

  renderDataRow = (row, index, workAreaName, rowKeyPrefix) => (
    <tr key={row.key || `${rowKeyPrefix}-${index}`}>
      <td className='sheet-number-col'>{index + 1}</td>
      <td>
        {row.awb_no ? row.awb_no.replace(/(\d{3})(\d{8})/, '$1-$2') : row.uld_no || ''}
      </td>
      <td>
        {row.location || ''}
      </td>
      <td>
        {row.delay || 0}
      </td>
      <td>{row.pri || ''}</td>
      <td>{row?.prod_code || ''}</td>
      <td>
        <Select
          value={row.yesNo || 'No'}
          onChange={(value) => this.updateResponseRow(workAreaName, rowKeyPrefix, index, 'yesNo', value)}
          size='small'
          className='w-100'
        >
          <Option value='Yes'>Yes</Option>
          <Option value='No'>No</Option>
        </Select>
      </td>
      <td><Input className='scrub-sheet-input' value={row.builtUlds || ''} onChange={(event) => this.updateResponseRow(workAreaName, rowKeyPrefix, index, 'builtUlds', event.target.value)} /></td>
      {/* <td colSpan={2}><Input className='scrub-sheet-input' value={row.comments || ''} onChange={(event) => this.updateResponseRow(workAreaName, rowKeyPrefix, index, 'comments', event.target.value)} /></td> */}
      <td colSpan={2}>
        <Select
          value={row.comments || ''}
          onChange={(value) => this.updateResponseRow(workAreaName, rowKeyPrefix, index, 'comments', value)}
          className='scrub-sheet-select'
          // bordered={false}
          size='small'
        >
          <Option value=''>Select Comment</Option>
          <Option value='Built'>Built</Option>
          <Option value='Not Tendered'>Not Tendered</Option>
          <Option value='Still at Origin / Has not arrived'>Still at Origin / Has not arrived</Option>
          <Option value='Hold / Block'>Hold / Block</Option>
          <Option value='No Space'>No Space</Option>
          <Option value='MEF'>MEF</Option>
          <Option value='Departed'>Departed</Option>
          <Option value='Partial Build'>Partial Build</Option>
          <Option value='No Time to Build'>No Time to Build</Option>
          <Option value='UTL'>UTL</Option>
          <Option value='Not Ready for Carriage'>Not Ready for Carriage</Option>
          <Option value='No Documents'>No Documents</Option>
          <Option value='ULD Availability'>ULD Availability</Option>
        </Select>
      </td>
      {/* <td className='sheet-action-col'>
        {row.key ? <Button danger type='text' size='small' onClick={() => this.removeResponseRow(row.key)}>Del</Button> : null}
      </td> */}
    </tr>
  )

  saveScrubCopy = () => {
    let completion = 0
    let compliance = 0
    let totalCompletion = 1
    let totalCompliance = 0

    this.state.workarea.forEach((workAreaName) => {
      const looseRows = this.state.workareaData?.[workAreaName]?.loose || []
      looseRows.forEach((row) => {
        if (row.awb_no && row.yesNo && row.builtUlds && (row.comments && row.comments !== '')) {
          completion += 1
        }
        if(row.comments && row.comments !== '' && const_comp.includes(row.comments)) {
          compliance += 1
        }
        totalCompletion += 1
        totalCompliance += 1
      })
      const uldRows = this.state.workareaData?.[workAreaName]?.uld || []
      uldRows.forEach((row) => {
        if (row.awb_no && row.yesNo && row.builtUlds && row.comments) {
          completion += 1
        }
        totalCompletion += 1
      })
    })
    if(this.state.finalConfig.PMC != 0 || this.state.finalConfig.PAG != 0 || this.state.finalConfig.LD2 != 0 || this.state.finalConfig.LD3 != 0 || this.state.finalConfig.LD48FQA != 0) {
      completion += 1
    }
    completion = completion > 0 ? Math.round((completion / (totalCompletion)) * 100) : 0

    compliance = totalCompletion > 0 ? Math.round((compliance / totalCompliance) * 100) : 0
    const scrubCopyData = {
      flight_id: this.props.data.id,
      station: this.state.station,
      scrub_data: { 
        maxConfig: this.state.maxConfig,
        plannedConfig: this.state.plannedConfig,
        finalConfig: this.state.finalConfig,
        workareaData: this.state.workareaData,
        summary: this.state.summary,
        summaryRows: this.state.summaryRows,
        completion,
        compliance,
        user: {
          name: cookies.get('name') || '',
          username: cookies.get('username') || '',
        },
        date: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      }
    }
    Http.post('/save_scrub_copy', scrubCopyData).then(({ data }) => {
      if (data?.status === 'success') {
        this.props.closeModal(false)
      }
    })
  }

  render() {
    const { flightNo, station, summaryRows } = this.state
    const hasData = this.props.data && Object.keys(this.props.data).length > 0
    const hideScrubCopy = this.props.hideScrubCopy ?? false

    return (
      <div className='scrub-sheet-container'>
        {!hideScrubCopy && (
          !hasData ?
            <div className='scrub-sheet-empty'>
              <Typography.Title level={4} className='scrub-no-data'>No data available</Typography.Title>
              <Typography.Text className='scrub-no-data'>Please select a flight to view the scrub copy</Typography.Text>
            </div>
            :
            <div>
              <div className='scrub-sheet-wrap'>
                <table className='scrub-sheet'>
                  <colgroup>
                    <col style={{ width: '50px' }} />
                    <col style={{ width: '120px' }} />
                    <col style={{ width: '64px' }} />
                    <col style={{ width: '64px' }} />
                    <col style={{ width: '58px' }} />
                    <col style={{ width: '64px' }} />
                    <col style={{ width: '64px' }} />
                    <col style={{ width: '100px' }} />
                    <col style={{ width: '140px' }} />
                    <col style={{ width: '60px' }} />
                  </colgroup>
                  <tbody>
                    <tr><td colSpan={10} className='sheet-flight-cell'>{flightNo} | {station}</td></tr>
                    <tr className='sheet-head'>
                      <td className='sheet-label-cell' colSpan={3}>Container Type</td>
                      <td className='sheet-col-head'>PMC</td>
                      <td className='sheet-col-head'>PAG</td>
                      <td className='sheet-col-head'>LD2</td>
                      <td className='sheet-col-head'>LD3</td>
                      <td className='sheet-col-head'>LD4/8/FQA</td>
                      <td colSpan={2} className='sheet-empty-cell' />
                    </tr>
                    <tr className='sheet-head'>
                      <td className='sheet-label-cell' colSpan={3}>Max Configuration</td>
                      <td>{this.state.maxConfig.PMC}</td>
                      <td>{this.state.maxConfig.PAG}</td>
                      <td>{this.state.maxConfig.LD2}</td>
                      <td>{this.state.maxConfig.LD3}</td>
                      <td>{this.renderConfigInput('LD48FQA', 'maxConfig')}</td>
                      <td colSpan={2} className='sheet-empty-cell' />
                    </tr>
                    <tr className='sheet-head'>
                      <td className='sheet-label-cell' colSpan={3}>Planned Configuration</td>
                      <td>{this.state.plannedConfig.PMC}</td>
                      <td>{this.state.plannedConfig.PAG}</td>
                      <td>{this.state.plannedConfig.LD2}</td>
                      <td>{this.state.plannedConfig.LD3}</td>
                      <td>{this.renderConfigInput('LD48FQA', 'plannedConfig')}</td>
                      <td colSpan={2} className='sheet-empty-cell' />
                    </tr>
                    <tr className='sheet-yellow'>
                      <td className='sheet-label-cell' colSpan={3}>Final Configuration</td>
                      <td>{this.renderConfigInput('PMC', 'finalConfig')}</td>
                      <td>{this.renderConfigInput('PAG', 'finalConfig')}</td>
                      <td>{this.renderConfigInput('LD2', 'finalConfig')}</td>
                      <td>{this.renderConfigInput('LD3', 'finalConfig')}</td>
                      <td>{this.renderConfigInput('LD48FQA', 'finalConfig')}</td>
                      <td className='sheet-note-cell' colSpan={2}>
                        {'<---Scrub desk please update this count when replying'}
                      </td>
                    </tr>
                    <tr className='sheet-blue'>

                    </tr>

                    <tr className='empty-row'>
                      <td colSpan={10} className=''></td>
                    </tr>
                
                    <tr className='sheet-blue'>
                      <td colSpan={10} className='sheet-title'>Flight Plan Response</td>
                    </tr>
                    <tr className='sheet-blue sheet-header-row'>
                      <td >Number</td>
                      <td>AWB/<br />Conveyances</td>
                      <td>Location</td>
                      <td>Days Delayed</td>
                      <td>Priority</td>
                      <td>Product</td>
                      <td>Yes/No</td>
                      <td>Built ULDs</td>
                      <td colSpan={2}>Scrub Desk Comments</td>
                    </tr>
                    {this.state?.workarea?.length > 0 && (
                      this.state.workarea.map((workAreaName) => {
                        const looseRows = this.state.workareaData?.[workAreaName]?.loose || []
                        const uldRows = this.state.workareaData?.[workAreaName]?.uld || []

                        return (
                          <React.Fragment key={workAreaName}>
                            <tr className='sheet-yellow'><td colSpan={10} className='sheet-group'>{workAreaName === 'UNKNOWN' ? 'Miscellaneous' : workAreaName}</td></tr>
                            {looseRows.length > 0 && (
                              <React.Fragment>
                                <tr className='sheet-gray'><td colSpan={10} className='sheet-group'>Loose</td></tr>
                                {looseRows.map((row, rowIndex) => this.renderDataRow(row, rowIndex, workAreaName, 'loose'))}
                              </React.Fragment>
                            )}
                            {uldRows.length > 0 && (
                              <React.Fragment>
                                <tr className='sheet-gray'><td colSpan={10} className='sheet-group'>Pre-Built</td></tr>
                                {uldRows.map((row, rowIndex) => this.renderDataRow(row, rowIndex, workAreaName, 'uld'))}
                              </React.Fragment>
                            )}
                            <tr className='empty-row'><td colSpan={10} className='' /></tr>
                          </React.Fragment>
                        )
                      })
                    )}

                    <tr className='sheet-blue'>
                      <td colSpan={10} className='sheet-summary-title'>Flight Summary</td>
                    </tr>
                    <tr>
                      <td colSpan={10} className='sheet-summary-cell'>
                        <Input.TextArea 
                          rows={4} 
                          placeholder='Add Summary' value={this.state.summary}
                          onChange={(event) => this.setState({ summary: event.target.value })} />
                      </td>
                    </tr>
                    <tr className='sheet-yellow'>
                      <td colSpan={10} className='sheet-group'>MEF</td>
                    </tr>
                    <tr className='empty-row'>
                      <td colSpan={10} className=''>
                        <Button type='dashed' onClick={this.addResponseRow} className='add-row-button'>+ Add Row</Button>
                      </td>
                    </tr>
                    <tr className='sheet-blue sheet-header-row'>
                      <td>Number</td>
                      <td>AWB/<br />Conveyances</td>
                      <td>Location</td>
                      <td>Days Delayed</td>
                      <td>Priority</td>
                      <td>Product</td>
                      <td>Yes/No</td>
                      <td>Built ULDs</td>
                      <td>Scrub Desk Comments</td>
                      <td> </td>
                    </tr>
                    {summaryRows.map((value, index) => (
                      <tr key={`summary-${index}`}>
                        <td className='sheet-number-col'>{index + 1}</td>
                        <td>
                          <Input
                            value={value.awb_no}
                            onChange={(event) => {
                              const rows = [...this.state.summaryRows]
                              rows[index].awb_no = event.target.value
                              this.setState({ summaryRows: rows })
                            }}
                            size='small'
                          />
                        </td>
                        <td>
                          <Input 
                            value={value.location}
                            onChange={(event) => {
                              const rows = [...this.state.summaryRows]
                              rows[index].location = event.target.value
                              this.setState({ summaryRows: rows })
                            }}
                            size='small'
                          />
                        </td>
                        <td>
                          <InputNumber
                            min={0}
                            value={value.delay}
                            onChange={(value) => {
                              const rows = [...this.state.summaryRows]
                              rows[index].delay = value || 0
                              this.setState({ summaryRows: rows })
                            }}
                            controls={false}
                            size='small'
                          /> 
                        </td>
                        <td>
                          <Input
                            value={value.pri}
                            onChange={(event) => {
                              const rows = [...this.state.summaryRows]
                              rows[index].pri = event.target.value
                              this.setState({ summaryRows: rows })
                            }}
                            size='small'
                          />
                        </td>
                        <td>
                          <Input
                            value={value.prod_code}
                            onChange={(event) => {
                              const rows = [...this.state.summaryRows]
                              rows[index].prod_code = event.target.value
                              this.setState({ summaryRows: rows })
                            }}
                            size='small'
                          />
                        </td>
                        <td>
                          <Select
                            value={value.yesNo || 'No'}
                            onChange={(value) => {
                              const rows = [...this.state.summaryRows]
                              rows[index].yesNo = value
                              this.setState({ summaryRows: rows })
                            }}
                            size='small'
                            className='w-100'
                          >
                            <Option value='Yes'>Yes</Option>
                            <Option value='No'>No</Option>
                          </Select>
                        </td>
                        <td>
                          <Input
                            value={value.builtUlds}
                            onChange={(event) => {
                              const rows = [...this.state.summaryRows]
                              rows[index].builtUlds = event.target.value
                              this.setState({ summaryRows: rows })
                            }}
                            size='small'
                          />
                        </td>
                        <td>
                          <Select
                            value={value.comments || ''}
                            onChange={(value) => {
                              const rows = [...this.state.summaryRows]
                              rows[index].comments = value
                              this.setState({ summaryRows: rows })
                            }}
                            className='scrub-sheet-select'
                            size='small'
                          >
                            <Option value=''>Select Comment</Option>
                            <Option value='Built'>Built</Option>
                            <Option value='Not Tendered'>Not Tendered</Option>
                            <Option value='Still at Origin / Has not arrived'>Still at Origin / Has not arrived</Option>
                            <Option value='Hold / Block'>Hold / Block</Option>
                            <Option value='No Space'>No Space</Option>
                            <Option value='MEF'>MEF</Option>
                            <Option value='Departed'>Departed</Option>
                            <Option value='Partial Build'>Partial Build</Option>
                            <Option value='No Time to Build'>No Time to Build</Option>
                            <Option value='UTL'>UTL</Option>
                            <Option value='Not Ready for Carriage'>Not Ready for Carriage</Option>
                            <Option value='No Documents'>No Documents</Option>
                            <Option value='ULD Availability'>ULD Availability</Option>
                          </Select>
                        </td>
                        <td className='sheet-action-col'>
                          <Popconfirm
                            placement='top'
                            title={constants.DeleteText}
                            onConfirm={() => {
                              this.removeResponseRow(index)
                            }}
                            okText='Yes'
                            cancelText='No'
                          >
                            <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                              <img src={deleteIcon} alt='delete' height={14} width='auto' />
                            </Tooltip>
                          </Popconfirm>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='scrub-actions scrub-actions-footer'>
                <Button className='custom-button min-width-110' onClick={() => this.props.closeModal(false)}>Close</Button>
                <div>
                  <Space direction='vertical' size={0}>
                    {this.state?.user?.name && <div className='mr-4'><b><CheckCircleTwoTone twoToneColor='#52c41a' /> Scrub Copy saved successfully</b></div>}
                    <span className='scrub-copy-saved-info'>
                      {this.state?.user?.name? `${this.state.user.name} ${this.state?.date ? moment.utc(this.state.date).tz(this.state.timezone).format('DDMMMYY HH:mm').toUpperCase() : ''}` : ''}
                    </span>
                  </Space>
                  <Button className='custom-button' type='primary' onClick={this.saveScrubCopy}>Save Scrub Copy</Button>
                </div>
              </div>
            </div>
        )
        }
      </div>
    )
  }
}

export default ScrubCopy